import {MuWidget} from "mu-widget/lib/MuWidget";

export class TicketRelField extends MuWidget {
	beforeIndex() {
		let w = this;
		while(w) {
			if ('loadTicket' in w) break;
			w = w.muParent;
		}
		if (w) {
			this.container.querySelectorAll('a').forEach(a => a.addEventListener('click', ev => {
				(w as any).loadTicket(parseInt(a.dataset['ticketid'] ?? "0"));
				ev.preventDefault();
			}))
		}
	}
}